import { useEffect, useState } from "react";

function useAriaUpdateHook(
  resultsCount: number | undefined,
  additive?: boolean,
) {
  const [ariaStatus, setAriaStatus] = useState("");

  useEffect(() => {
    if (typeof resultsCount !== "undefined") {
      if (resultsCount > 0) {
        setAriaStatus(
          `update: got ${resultsCount}${additive ? " additional" : ""} results`,
        );
      } else {
        setAriaStatus(`update: No results`);
      }
    }
  }, [resultsCount]);

  return {
    ariaStatus,
  };
}

export default useAriaUpdateHook;
